import React, { Component } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import Loader from 'react-loader-spinner';

function App(props) {
  return (<LoadingIndicator />
  )
}

const LoadingIndicator = props => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress &&

    <div className="modal loading-popup">
      <Loader type="TailSpin" color="#007c34" height="100" width="100" />
    </div>

  );
}

export default App;